import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';
import MainImg from '../assets/img/signin2.png'


const Register1 = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <div className="container">
                <div className="row mt-3">
                    <div className="col-sm-1-my text-center">
                        <p><Link to="/Signin2" className="text-decoration-none"><i className="fa fa-angle-left fa-angle-left-reg" aria-hidden="true">
                        </i></Link></p>
                    </div>
                    <div className="col-sm-11-my text-center ">

                        <h3 className="font-weight-bold signin1-h1  ">Register</h3>
                    </div>

                </div>
            </div>
            <div className="  p-4 mt-2" style={{ borderRadius: "25px 25px 0 0", boxShadow: "0 -0.3rem 1rem rgba(0,0,0,.15)" }}>
                <div className="row ">
                    <div className="col-sm-12">
                        <div className="">
                            <form className="signin2-form">

                                <div className="row">
                                    <div className="col-sm-6 col">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">First Name </label>
                                            <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="First Name" />
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col">

                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Last Name </label>
                                            <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Last Name" />
                                        </div>

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6 col">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Phone Number </label>
                                            <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Zip Code" />
                                        </div>

                                    </div>
                                    <div className="col-sm-6 col">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Zip Code </label>
                                            <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Zip Code" />
                                        </div>

                                    </div>
                                </div>




                                <div className="form-group">
                                    <label for="exampleInputEmail1">Prefered className=</label>
                                    <select className="form-control" id="exampleFormControlSelect1">
                                        <option default selected>Prefered Stores</option>
                                        <option>D Mart Store</option>
                                        <option>Big Bazzar Store</option>
                                        <option>Best Price Store</option>
                                        <option>Relience Store</option>
                                    </select>
                                </div>


                                <div className="form-group">
                                    <label for="exampleInputEmail1">Email Address</label>
                                    <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Email Address" />
                                </div>

                                <div className="row">
                                    <div className="col-sm-6 col">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">PIN </label>
                                            <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="4 Digit PIN" />
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Confirm PIN </label>
                                            <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Confirm PIN" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                    <div className="form-check px-3 mt-3">
                                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                        <label className="form-check-label font-weight-bold " style={{opacity:"0.5"}} for="exampleCheck1">Agree to our
                                            <a href="" className="text-red text-decoration-none"> Term's </a>& <a href="" className="text-red text-decoration-none">Conditions </a>and
                                            <a href="" className="text-red text-decoration-none"> Privacy Policy</a>.</label>
                                    </div>
                         
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-sm-12 bottom-btm-font mt-2">
                        <button type="button" className="btn btn-success w-100 mt-3 py-2 ">Register</button>
                        <button type="button" className="btn btn-outline-danger w-100 mt-3 py-2" >Cancel</button>

                    </div>
                </div>
            </div>


        </div>
    )
}

export default Register1;